/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-no-found',
    templateUrl: './page-no-found.component.html',
    styleUrls: ['./page-no-found.component.less'],
    standalone: false
})
export class PageNoFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
